import { EnumCommodity, EnumPrecioUnitario, EnumTipoPeaje } from '../../../api'
import {
  PriceComponentAPI,
  PriceComponentTable
} from '../../../api/Argentia/endpoints/priceComponents'
import { PricesModel } from '../../../api/Argentia/endpoints/pricing/model/prices'
import { EnumRedondeo } from '../../../api/Argentia/enums'
import { EnumPriceComponentReference } from '../../../api/Argentia/enums/enumPriceComponentReference'
import { EnumPriceType } from '../../../api/oData/enums/enumPriceType'
import { enumEnumToValueNumber } from '../../../helpers'

export const priceComponentsTableModelListMapper = (
  priceComponents?: PriceComponentAPI[]
): PriceComponentTable[] | undefined => {
  return priceComponents ? priceComponents.map(priceComponentsTableModelItemMapper) : undefined
}

export const priceComponentsTableModelItemMapper = (
  priceComponent: PriceComponentAPI
): PriceComponentTable => {
  return {
    ...priceComponent,
    isParameter:
      enumEnumToValueNumber(EnumPriceType, priceComponent.priceType) === EnumPriceType.Parametro,
    commodity: enumEnumToValueNumber(EnumCommodity, priceComponent.commodity)!,
    currentPriceValue:
      enumEnumToValueNumber(EnumPriceType, priceComponent.priceType) === EnumPriceType.Parametro
        ? priceComponent.currentPriceValue?.toString()
        : 'Complejo',
    currentPriceValueString:
      enumEnumToValueNumber(EnumPriceType, priceComponent.priceType) === EnumPriceType.Apuntamiento
        ? ['Complejo']
        : (priceComponent.currentPriceValueString ?? [])
  }
}

export const priceComponentsDefaultAPIListMapper = (priceComponents: PriceComponentAPI[]) => {
  return priceComponents.map(priceComponentsAPIItemMapper)
}

export const priceComponentsAPIListMapper = (priceComponents: PriceComponentAPI[]) => {
  return priceComponents
    .filter(p => p.idContract || p.idFlexibility || p.toll || p.idLead)
    .map(priceComponentsAPIItemMapper)
}

export const priceComponentsAPIItemMapper = (priceComponent: PriceComponentAPI) => {
  return {
    ...priceComponent,
    priceType: enumEnumToValueNumber(EnumPriceType, priceComponent.priceType)!,
    priceReference: enumEnumToValueNumber(
      EnumPriceComponentReference,
      priceComponent.priceReference
    ),
    toll: enumEnumToValueNumber(EnumTipoPeaje, priceComponent.toll)
  }
}

export const priceMapper = (price: PricesModel): any => {
  const { redondeo, precioUnitario, ...restPrice } = price

  return {
    ...restPrice,
    round: enumEnumToValueNumber(EnumRedondeo, price.redondeo)!,
    priceUnit: enumEnumToValueNumber(EnumPrecioUnitario, price.precioUnitario)!,
    idEmpresa: price.empresa || 1
  }
}
